var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2755_2781)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 8.94268L11.7714 12.714C11.8971 12.8355 12.0655 12.9027 12.2403 12.9011C12.4151 12.8996 12.5823 12.8295 12.7059 12.7059C12.8295 12.5823 12.8996 12.4151 12.9012 12.2403C12.9027 12.0655 12.8355 11.8971 12.714 11.7714L8.94271 8.00002L12.714 4.22868C12.8355 4.10295 12.9027 3.93455 12.9012 3.75975C12.8996 3.58495 12.8295 3.41774 12.7059 3.29414C12.5823 3.17053 12.4151 3.10042 12.2403 3.0989C12.0655 3.09738 11.8971 3.16458 11.7714 3.28602L8.00004 7.05735L4.22871 3.28602C4.10241 3.16758 3.93499 3.10293 3.76187 3.10574C3.58874 3.10855 3.42351 3.17861 3.30112 3.30108C3.17873 3.42356 3.10879 3.58884 3.1061 3.76197C3.10341 3.93509 3.16819 4.10247 3.28671 4.22868L7.05738 8.00002L3.28604 11.7714C3.22237 11.8328 3.17158 11.9064 3.13664 11.9877C3.1017 12.0691 3.08331 12.1566 3.08254 12.2451C3.08178 12.3336 3.09864 12.4214 3.13216 12.5033C3.16568 12.5853 3.21519 12.6597 3.27778 12.7223C3.34038 12.7849 3.41481 12.8344 3.49674 12.8679C3.57867 12.9014 3.66646 12.9183 3.75498 12.9175C3.8435 12.9167 3.93098 12.8984 4.01231 12.8634C4.09365 12.8285 4.16721 12.7777 4.22871 12.714L8.00004 8.94268Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2755_2781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGray400);
export default __webpack_public_path__ + "static/media/x_gray400.8e9ee9e97fef97eb7ae7556522ef0fdb.svg";
export { ForwardRef as ReactComponent };